import { QuestionBase } from "../../form/models/question-base.model";
// import { AssessmentQuestionBase } from "./assessment-question-base.model";

export class SingleChoiceQuestion extends QuestionBase<string> {
    controlType = 'single-choice-question';
    singleChoicetype: string;
    placeholder: string;
    disabled: boolean;
    visible: boolean;
    searchable: boolean;
    cstm_error_msg:any;
    conditions: any=[];
    options: any=[];
    pattern: string;
    maxlength: string;
    minlength: string;
    populate_field: boolean;

  constructor(options: {} = {}) {
    super(options);
    this.singleChoicetype = options['singleChoicetype'] || '';
    this.placeholder = options['placeholder'] || '';
    this.disabled = options['disabled'] || '';
    this.options = options['options'];
    this.visible = (options['visible'] == undefined) ? true : options['visible'];
    this.searchable = (options['searchable'] == undefined) ? false : options['searchable'];
    this.cstm_error_msg = options['cstm_error_msg'];
    this.conditions = options['conditions'];
    this.required = (options['required'] == undefined) ? false : options['required'];
    this.populate_field = (options['populate_field'] == undefined) ? false : options['populate_field'];
    this.pattern = options['pattern'] || '';
    this.maxlength = options['maxlength'] || '';
    this.minlength = options['minlength'] || '';
  }
}
